var _circle, _path, _ellipse;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9992,
    r: 11.5,
    stroke: "black",
    strokeWidth: 2.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.3977L16 13.5977",
    stroke: "black",
    strokeWidth: 2.6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9999,
    cy: 10.4008,
    rx: 1.6,
    ry: 1.6,
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.9c3f24dd5201396e0626580e5f1208a8.svg";
export { ForwardRef as ReactComponent };